import {buildServerCall} from '../services/wcfService';
import {getConnection} from '../_shared/GWTBridge/invoke/genPage';
import {getCachedData} from '../services/cacheService';

export function getMessageByKey(
    ename: string,
    messageNum: number,
    par1: string = '',
    par2: string = '',
    par3: string = ''
) {
    const parameters = {
        ename: [ename],
        message: [messageNum.toString()],
        par1: [par1],
        par2: [par2],
        par3: [par3]
    };
    return buildServerCall('GeneralSqlMessage', parameters, 'Get SQL Message', true, getConnection);
}

export function getEntityMessages(ename: string) {
    const parameters = {ename: [ename]};

    return getCachedData(ename).then(cachedMessages => {
        return (
            cachedMessages ||
            buildServerCall(
                'GeneralExtMessages',
                parameters,
                'Get Server Messages',
                true,
                getConnection
            )
        );
    });
}
